import { SignupCheckpoint } from '../../data-types/signup/signupInterfaces';
import { store } from '../store';
import {
  SET_CURRENT_SIGNUP_PATH,
  SET_HAS_JUST_SIGNED_UP,
  SET_INITIAL_SIGNUP_LOAD,
  SET_IS_AFTER_ZIMPLER_SIGN_UP,
  SET_SIGNUP_CHECKPOINT,
  SET_SIGNUP_CHOICE_DIALOG_OPEN,
  SET_SIGNUP_DIALOG_OPEN,
  SET_USE_SIGNUP_V3,
  SET_ZIMPLER_SIGNUP_DIALOG_OPEN,
} from '../types/signupTypes';

export const setInitialSignUpLoad = (isInitial: boolean) => {
  store.dispatch({
    type: SET_INITIAL_SIGNUP_LOAD,
    meta: isInitial,
  });
};

export const setCurrentSignUpPath = (path: string) => {
  store.dispatch({
    type: SET_CURRENT_SIGNUP_PATH,
    meta: path,
  });
};

export const setSignupChoiceDialogOpen = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_SIGNUP_CHOICE_DIALOG_OPEN,
  });
};

export const setZimplerSignupDialogOpen = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_ZIMPLER_SIGNUP_DIALOG_OPEN,
  });
};

export const setSignUpDialogOpen = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_SIGNUP_DIALOG_OPEN,
  });
};

export const setUseSignupV3 = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_USE_SIGNUP_V3,
  });
};

export const setSignupCheckpoint = (meta: SignupCheckpoint | undefined) => {
  store.dispatch({
    meta,
    type: SET_SIGNUP_CHECKPOINT,
  });
};

export const setIsAfterZimplerSignup = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_IS_AFTER_ZIMPLER_SIGN_UP,
  });
};

export const setHasJustSignedUp = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_HAS_JUST_SIGNED_UP,
  });
};
